export const glyphiconMap = {
    // User / People
    'glyphicon-user': 'mdi-account',
    'glyphicon-user-add': 'mdi-account-plus',
    'glyphicon-user-remove': 'mdi-account-remove',
    'glyphicon-user-ok': 'mdi-account-check',
    'glyphicon-user-lock': 'mdi-account-lock',
    'glyphicon-user-alert': 'mdi-account-alert',
    'glyphicon-user-heart': 'mdi-account-heart',
    'glyphicon-user-star': 'mdi-account-star',
    'glyphicon-user-time': 'mdi-account-clock',

    // Home / UI
    'glyphicon-home': 'mdi-home',
    'glyphicon-dashboard': 'mdi-view-dashboard',
    'glyphicon-cog': 'mdi-cog',
    'glyphicon-wrench': 'mdi-wrench',
    'glyphicon-briefcase': 'mdi-briefcase',

    // Files
    'glyphicon-file': 'mdi-file',
    'glyphicon-file-empty': 'mdi-file-outline',
    'glyphicon-file-text': 'mdi-file-document',
    'glyphicon-file-text-alt': 'mdi-file-document-outline',
    'glyphicon-folder-open': 'mdi-folder-open',
    'glyphicon-folder-close': 'mdi-folder',
    'glyphicon-download': 'mdi-download',
    'glyphicon-upload': 'mdi-upload',

    // Actions
    'glyphicon-search': 'mdi-magnify',
    'glyphicon-remove': 'mdi-close',
    'glyphicon-remove-circle': 'mdi-close-circle',
    'glyphicon-ok': 'mdi-check',
    'glyphicon-ok-circle': 'mdi-check-circle',
    'glyphicon-plus': 'mdi-plus',
    'glyphicon-plus-sign': 'mdi-plus-circle',
    'glyphicon-minus': 'mdi-minus',
    'glyphicon-edit': 'mdi-pencil',
    'glyphicon-pencil': 'mdi-pencil',
    'glyphicon-trash': 'mdi-delete',
    'glyphicon-print': 'mdi-printer',
    'glyphicon-refresh': 'mdi-refresh',
    'glyphicon-repeat': 'mdi-repeat',
    'glyphicon-lock': 'mdi-lock',
    'glyphicon-unlock': 'mdi-lock-open',

    // Navigation
    'glyphicon-chevron-left': 'mdi-chevron-left',
    'glyphicon-chevron-right': 'mdi-chevron-right',
    'glyphicon-chevron-up': 'mdi-chevron-up',
    'glyphicon-chevron-down': 'mdi-chevron-down',
    'glyphicon-arrow-left': 'mdi-arrow-left',
    'glyphicon-arrow-right': 'mdi-arrow-right',
    'glyphicon-arrow-up': 'mdi-arrow-up',
    'glyphicon-arrow-down': 'mdi-arrow-down',

    // Media
    'glyphicon-play': 'mdi-play',
    'glyphicon-pause': 'mdi-pause',
    'glyphicon-stop': 'mdi-stop',
    'glyphicon-forward': 'mdi-skip-forward',
    'glyphicon-backward': 'mdi-skip-backward',
    'glyphicon-volume-up': 'mdi-volume-high',
    'glyphicon-volume-down': 'mdi-volume-medium',
    'glyphicon-volume-off': 'mdi-volume-off',

    // Communication
    'glyphicon-envelope': 'mdi-email',
    'glyphicon-phone': 'mdi-phone',
    'glyphicon-comment': 'mdi-comment',
    'glyphicon-comments': 'mdi-comment-multiple',
    'glyphicon-earphone': 'mdi-headphones',

    // Alerts
    'glyphicon-warning-sign': 'mdi-alert',
    'glyphicon-info-sign': 'mdi-information',
    'glyphicon-question-sign': 'mdi-help-circle',
    'glyphicon-exclamation-sign': 'mdi-alert-circle',

    // Time
    'glyphicon-time': 'mdi-clock-outline',
    'glyphicon-calendar': 'mdi-calendar',
    'glyphicon-hourglass': 'mdi-hourglass',

    // Visual
    'glyphicon-eye-open': 'mdi-eye',
    'glyphicon-eye-close': 'mdi-eye-off',
    'glyphicon-heart': 'mdi-heart',
    'glyphicon-heart-empty': 'mdi-heart-outline',
    'glyphicon-star': 'mdi-star',
    'glyphicon-star-empty': 'mdi-star-outline',
    'glyphicon-camera': 'mdi-camera',
    'glyphicon-picture': 'mdi-image',
    'glyphicon-map-marker': 'mdi-map-marker',

    // Shopping
    'glyphicon-shopping-cart': 'mdi-cart',
    'glyphicon-tag': 'mdi-tag',
    'glyphicon-tags': 'mdi-tag-multiple',
    'glyphicon-gift': 'mdi-gift',

    // Misc
    'glyphicon-globe': 'mdi-earth',
    'glyphicon-flag': 'mdi-flag',
    'glyphicon-education': 'mdi-school',
    'glyphicon-fire': 'mdi-fire',
    'glyphicon-leaf': 'mdi-leaf',
    'glyphicon-plane': 'mdi-airplane',
    'glyphicon-road': 'mdi-road',
    'glyphicon-stats': 'mdi-chart-bar',

    // API / Lists
    'glyphicon-barcode': 'mdi-barcode',
    'glyphicon-list': 'mdi-format-list-bulleted',
    'glyphicon-th-list': 'mdi-view-list',
    'glyphicon-list-alt': 'mdi-format-list-text',
    'glyphicon-zoom-in': 'mdi-magnify-plus',
}

export function mapIcon(icon) {
    if (!icon) return null
    return glyphiconMap[icon.trim()] || null
}